import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { initSentry } from './sentry.config';

if (environment.production) {
  enableProdMode();
}

initSentry();


platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
